import './qlCategory.css'

/* Flat list row used for both Categories and Topics columns (Modernist handoff). */
const QlCategory = (props) => {
    const { selected, onCategorySelected, onCatStatusChanged, value, status, sub } = props
    return (
        <div
            onClick={onCategorySelected}
            className={selected ? undefined : 'tyk-row-btn'}
            style={{
                display: 'flex', alignItems: 'center', gap: 10, padding: '11px 12px',
                borderLeft: `3px solid ${selected ? 'var(--color-accent)' : 'transparent'}`,
                background: selected ? 'var(--color-accent-100)' : 'transparent',
                cursor: 'pointer',
            }}
        >
            <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 600, fontSize: 14, color: selected ? 'var(--color-accent)' : 'var(--color-text)' }}>{value}</div>
                {sub ? <div style={{ fontSize: 11 }} className="text-muted">{sub}</div> : null}
            </div>
            <span
                onClick={onCatStatusChanged}
                className={status === 'Active' ? 'tag tag-accent' : 'tag tag-neutral'}
                style={{ cursor: 'pointer', flex: 'none' }}
                title="Toggle status"
            >{status}</span>
        </div>
    )
}
export default QlCategory
